"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentConfirmation = PaymentConfirmation;
exports.PaymentConfirmationV3 = PaymentConfirmationV3;
exports.default = watchers;
exports.initiatePayment = initiatePayment;
exports.initiatePaymentV3 = initiatePaymentV3;
exports.initiatePaymentV4 = initiatePaymentV4;
exports.initiatePaymentV5 = initiatePaymentV5;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* applyCouponCodeSaga(params) {
  try {
    var _params$data;
    const {
      showLoader = true
    } = params === null || params === void 0 ? void 0 : params.data;
    if ((0, _utils.isMobile)() && showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.APPLY_COUPON_CODE_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const queryParams = params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.params;
    const mainResponse = yield (0, _effects.call)(api.applyCouponCodeApi, queryParams, tokenData);
    yield (0, _effects.put)(actions.APPLY_COUPON_CODE_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.APPLY_COUPON_CODE_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* deleteCouponCodeSaga(params) {
  try {
    var _params$data2;
    const {
      showLoader = true
    } = params === null || params === void 0 ? void 0 : params.data;
    if ((0, _utils.isMobile)() && showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.DELETE_COUPON_CODE_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const queryParams = params === null || params === void 0 || (_params$data2 = params.data) === null || _params$data2 === void 0 ? void 0 : _params$data2.params;
    const mainResponse = yield (0, _effects.call)(api.deleteCouponCodeApi, queryParams, tokenData);
    yield (0, _effects.put)(actions.DELETE_COUPON_CODE_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.DELETE_COUPON_CODE_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* listOfCouponCodeSaga(params) {
  try {
    var _params$data3;
    const {
      showLoader = true
    } = params === null || params === void 0 ? void 0 : params.data;
    if ((0, _utils.isMobile)() && showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.LIST_OF_COUPON_CODE_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.listOfCouponCodeApi, params === null || params === void 0 || (_params$data3 = params.data) === null || _params$data3 === void 0 ? void 0 : _params$data3.params, tokenData);
    yield (0, _effects.put)(actions.LIST_OF_COUPON_CODE_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.LIST_OF_COUPON_CODE_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* initiatePayment(requestParams) {
  try {
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.initiatePayment, requestParams, tokenData);
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* initiatePaymentV3(requestParams) {
  try {
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API_V3.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.initiatePaymentV3, requestParams, tokenData);
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API_V3.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API_V3.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* initiatePaymentV5(requestParams) {
  try {
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API_V5.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.initiatePaymentV5, requestParams, tokenData);
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API_V5.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API_V5.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* initiatePaymentV4(requestParams) {
  try {
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API_V4.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.initiatePaymentV4, requestParams, tokenData);
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API_V4.success(mainResponse));
    requestParams.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.EPHARMACY_INITIATE_PAYMENT_API_V4.failure(err));
    requestParams.data.onFailure(err);
  }
}
function* PaymentConfirmation(params) {
  try {
    yield (0, _effects.put)(actions.PAYMENT_CONFIRMATION_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.PaymentConfirmation, params, tokenData);
    yield (0, _effects.put)(actions.PAYMENT_CONFIRMATION_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.PAYMENT_CONFIRMATION_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getPaymentMethods(params) {
  try {
    const {
      showLoader = false
    } = (params === null || params === void 0 ? void 0 : params.data) || {};
    if ((0, _utils.isMobile)() && showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.SET_PAYMENT_METHOD_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getPaymentMethod, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PAYMENT_METHODS_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PAYMENT_METHODS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* PaymentConfirmationV3(params) {
  try {
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.PaymentConfirmationV3, params, tokenData);
    yield (0, _effects.put)(actions.PAYMENT_CONFIRMATION_API_V3.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.PAYMENT_CONFIRMATION_API_V3.failure(err));
    params.data.onFailure(err);
  }
}
function* setPaymentMethodSaga(params) {
  try {
    const {
      showLoader = true
    } = (params === null || params === void 0 ? void 0 : params.data) || {};
    if ((0, _utils.isMobile)() && showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.SET_PAYMENT_METHOD_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.setPaymentMethodApi, params.data.params, tokenData);
    yield (0, _effects.put)(actions.SET_PAYMENT_METHOD_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.SET_PAYMENT_METHOD_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* createOrder(params) {
  try {
    var _params$data4, _params$data5;
    yield (0, _effects.put)(actions.CREATE_ORDER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.createOrder, params === null || params === void 0 || (_params$data4 = params.data) === null || _params$data4 === void 0 ? void 0 : _params$data4.params, tokenData);
    yield (0, _effects.put)(actions.CREATE_ORDER_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data5 = params.data) !== null && _params$data5 !== void 0 && _params$data5.onSuccess) {
      params.data.onSuccess(mainResponse !== null && mainResponse !== void 0 ? mainResponse : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data6;
    yield (0, _effects.put)(actions.CREATE_ORDER_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data6 = params.data) !== null && _params$data6 !== void 0 && _params$data6.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* setPaymentMode(params) {
  try {
    var _params$data7, _params$data8;
    const {
      showLoader
    } = (params === null || params === void 0 ? void 0 : params.data) || {};
    if ((0, _utils.isMobile)() && showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.SET_PAYMENT_METHOD_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.setPaymentMode, params === null || params === void 0 || (_params$data7 = params.data) === null || _params$data7 === void 0 ? void 0 : _params$data7.params, tokenData);
    yield (0, _effects.put)(actions.SET_PAYMENT_MODE_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data8 = params.data) !== null && _params$data8 !== void 0 && _params$data8.onSuccess) {
      var _mainResponse$body;
      params.data.onSuccess((_mainResponse$body = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body !== void 0 ? _mainResponse$body : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data9;
    yield (0, _effects.put)(actions.SET_PAYMENT_MODE_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data9 = params.data) !== null && _params$data9 !== void 0 && _params$data9.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* watchers() {
  yield (0, _effects.takeLatest)(actions.APPLY_COUPON_CODE, applyCouponCodeSaga);
  yield (0, _effects.takeLatest)(actions.DELETE_COUPON_CODE, deleteCouponCodeSaga);
  yield (0, _effects.takeEvery)(actions.LIST_OF_COUPON_CODE, listOfCouponCodeSaga);
  yield (0, _effects.takeLatest)(actions.EPHARMACY_INITIATE_PAYMENT, initiatePayment);
  yield (0, _effects.takeLatest)(actions.EPHARMACY_INITIATE_PAYMENT_V3, initiatePaymentV3);
  yield (0, _effects.takeLatest)(actions.EPHARMACY_INITIATE_PAYMENT_V4, initiatePaymentV4);
  yield (0, _effects.takeLatest)(actions.EPHARMACY_INITIATE_PAYMENT_V5, initiatePaymentV5);
  yield (0, _effects.takeLatest)(actions.PAYMENT_CONFIRMATION, PaymentConfirmation);
  yield (0, _effects.takeLatest)(actions.PAYMENT_CONFIRMATION_V3, PaymentConfirmationV3);
  yield (0, _effects.takeLatest)(actions.SET_PAYMENT_METHOD, setPaymentMethodSaga);
  yield (0, _effects.takeLatest)(actions.GET_PAYMENT_METHODS, getPaymentMethods);
  yield (0, _effects.takeLatest)(actions.CREATE_ORDER, createOrder);
  yield (0, _effects.takeLatest)(actions.SET_PAYMENT_MODE, setPaymentMode);
}